import { Outlet } from "react-router-dom";
import SidebarNav from "./SidebarNav";

const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <SidebarNav />
      <div className="lg:ml-[160px] pt-14 lg:pt-11">
        <Outlet />
      </div>
    </div>
  );
};

export default PublicLayout;
